import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Login',
        redirect: '/Login'
    },
    {
        path: '/Login',
        name: '登录',
        component: () =>
            import ('../views/Login.vue')
    },
    //大屏
    {
        path: '/BigScreen',
        name: '大屏主页',
        component: () =>
            import ('../views/BigScreen.vue'),
    },
    {
        path: '/ProductionBigScreen',
        name: '生产',
        component: () =>
            import ('../views/ProductionBigScreen.vue'),
    },
    {
        path: '/SaleBigScreen',
        name: '销售',
        component: () =>
            import ('../views/SaleBigScreen.vue'),
    },
    {
        path: '/CollectionBigScreen',
        name: '收款',
        component: () =>
            import ('../views/CollectionBigScreen.vue'),
    },
    {
        path: '/ServiceBigScreen',
        name: '服务',
        component: () =>
            import ('../views/ServiceBigScreen.vue'),
    },
    {
        path: '/TowerBigScreen',
        name: '塔机详情',
        component: () =>
            import ('../views/TowerBigScreen.vue'),
    },
    {
        path: '/LifterBigScreen',
        name: '升降机详情',
        component: () =>
            import ('../views/LifterBigScreen.vue'),
    },
    {
        path: '/CompanyBigScreen',
        name: '公司详情',
        component: () =>
            import ('../views/CompanyBigScreen.vue'),
    },
    {
        path: '/AbnormalBigScreen',
        name: '异常详情',
        component: () =>
            import ('../views/AbnormalBigScreen.vue'),
    },
    {
        path: '/Index',
        name: '主页',
        component: () =>
            import ('../views/Index.vue'),
        redirect: '/Home',
        children: [{
                path: '/Home',
                name: '首页',
                component: () =>
                    import ('../views/Home.vue'),
            },
            //系统管理
            {
                path: '/FactoryManage',
                name: '厂商管理',
                component: () =>
                    import ('../views/FactoryManage.vue'),
            },
            {
                path: '/RoleManage',
                name: '厂商角色',
                component: () =>
                    import ('../views/RoleManage.vue'),
            },
            //信息管理
            {
                path: '/CustomerManage',
                name: '客户资料',
                component: () =>
                    import ('../views/CustomerManage.vue'),
            },
            {
                path: '/ModelManage',
                name: '产品型号',
                component: () =>
                    import ('../views/ModelManage.vue'),
            },
            {
                path: '/SalesCompanyManage',
                name: '销售公司',
                component: () =>
                    import ('../views/SalesCompanyManage.vue'),
            },
            //设备管理
            {
                path: '/DeviceManage',
                name: '监控主机',
                component: () =>
                    import ('../views/DeviceManage.vue'),
            },
            {
                path: '/VideoManage',
                name: '视频注册',
                component: () =>
                    import ('../views/VideoManage.vue'),
            },
            {
                path: '/MachineManage',
                name: '设备管理',
                component: () =>
                    import ('../views/MachineManage.vue'),
            },
            {
                path: '/LockHistory',
                name: '设备管理',
                component: () =>
                    import ('../views/LockHistory.vue'),
            },
            //服务管理
            {
                path: '/NodeManage',
                name: '服务网点',
                component: () =>
                    import ('../views/NodeManage.vue'),
            },
            {
                path: '/NodePersonManage',
                name: '服务人员',
                component: () =>
                    import ('../views/NodePersonManage.vue'),
            },
            {
                path: '/RepairManage',
                name: '服务记录',
                component: () =>
                    import ('../views/RepairManage.vue'),
            },
            //按揭管理
            {
                path: '/LoanManage',
                name: '还款管理',
                component: () =>
                    import ('../views/LoanManage.vue'),
            },
            {
                path: '/LoanHistory',
                name: '还款记录',
                component: () =>
                    import ('../views/LoanHistory.vue'),
            },
            //系统管理
            {
                path: '/UserManage',
                name: '用户管理',
                component: () =>
                    import ('../views/UserManage.vue'),
            },
        ]
    },

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    if (to.path == "/Login") {
        next();
    } else {
        const token = JSON.parse(localStorage.getItem("user")) && JSON.parse(localStorage.getItem("user")).accessToken;
        if (token) {
            next();
        } else {
            router.push({
                path: "/Login"
            });
        }
    }
});

export default router